// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__wqDlu","inputWrap":"styles_inputWrap__2GL9i","input":"styles_input__A32na"};